import {
  deleteAdminV1StoresStoreIdPoliciesId,
  getAdminV1StoresStoreIdPolicies,
  getAdminV1StoresStoreIdPoliciesId,
  patchAdminV1StoresStoreIdPoliciesId,
  postAdminV1StoresStoreIdPolicies,
  type PatchAdminV1StoresStoreIdPoliciesIdBody,
  type Policy,
  type PostAdminV1StoresStoreIdPoliciesBody,
} from '@nucleus-commerce/api-client/admin';

/** Policy documents of one store: a bounded list (50), so it comes back whole. */
export const policiesApi = {
  list: (storeId: string): Promise<Policy[]> =>
    getAdminV1StoresStoreIdPolicies({ storeId }).then((r) => r.items),
  get: (storeId: string, id: string): Promise<Policy> =>
    getAdminV1StoresStoreIdPoliciesId({ storeId, id }),
  create: (storeId: string, body: PostAdminV1StoresStoreIdPoliciesBody): Promise<Policy> =>
    postAdminV1StoresStoreIdPolicies({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdPoliciesIdBody,
  ): Promise<Policy> => patchAdminV1StoresStoreIdPoliciesId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdPoliciesId({ storeId, id }),
};
